'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_time_zone_ZoneRules() {
}
export { $c_Ljava_time_zone_ZoneRules as $c_Ljava_time_zone_ZoneRules };
$p = $c_Ljava_time_zone_ZoneRules.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_zone_ZoneRules;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules() {
}
export { $h_Ljava_time_zone_ZoneRules as $h_Ljava_time_zone_ZoneRules };
$h_Ljava_time_zone_ZoneRules.prototype = $p;
